import ContextualTargetingList from 'common/pages/contextual-targeting/ContextualTargetingList'

export const ContextualTargetingListAdvertiser = () => <ContextualTargetingList />
